import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRipple } from '@angular/material/core';
import {
  MatSnackBarLabel,
  MatSnackBarActions,
  MatSnackBarAction,
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
} from '@angular/material/snack-bar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HighlightedMessageComponent } from '../highlighted-message/highlighted-message.component';

@Component({
  selector: 'app-snackbar',
  imports: [
    FontAwesomeModule,
    MatButtonModule,
    MatSnackBarLabel,
    MatSnackBarActions,
    MatSnackBarAction,
    MatRipple,
    HighlightedMessageComponent,
  ],
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss',
})
export class SnackbarComponent {
  readonly snackBarRef = inject(MatSnackBarRef);

  readonly data = inject(MAT_SNACK_BAR_DATA);

  get text(): string {
    return this.data?.text || 'No message';
  }

  get highlights(): string[] {
    return this.data?.highlights ?? [];
  }
}
